import dayjs from "dayjs";
import { General } from "./smartComponents/General";
import { Goals } from "./smartComponents/Goals";
import { Dashboard } from "./smartComponents/Dashboard";
import { Retention } from "./smartComponents/Retention";
import { Extra } from "./smartComponents/Extra";
import { Pages } from "./smartComponents/Pages";
import { Clubready } from "./smartComponents/Clubready";

const MIN_YEAR = 2012;
const CURRENT_YEAR = dayjs().year();

function getActiveYears() {
  let years = [];

  for (let i = MIN_YEAR; i <= CURRENT_YEAR; i++) {
    years.push({ name: i });
  }

  return years.reverse();
}

export const FILTER_OPTIONS = {
  activeYears: getActiveYears(),
  currencyList: ["$", "€", "£"],
  beginningOfWeek: [
    { id: "sunday", name: "Sunday" },
    { id: "monday", name: "Monday" }
  ],
  dailyEmailNotifier: ["DailyEmailNotifier", "RowHouseDailyEmailNotifier"],
  attritionRateLogic: [
    { id: "rolling30Days", name: "Rolling 30 Days" },
    { id: "monthly", name: "Monthly" }
  ],
  membershipMetrics: [
    { id: "NumberOfMembersByStatus", name: "Number Of MembersByStatus - iKizmet logic" },
    { id: "NumberOfMembersByProfile", name: "Number Of Members By Profile - Clubready logic" },
    {
      id: "NumberOfPayingMembersByPricingOption",
      name: "Number Of Paying MembersBy Pricing Option"
    },
    {
      id: "NumberOfPayingMembersByPricingOptionExcludingZeroSales",
      name: "Number Of Paying MembersBy Pricing Option Excluding Zero Sales"
    }
  ],
  membershipStart: [
    { id: "sale_date", name: "Sale Date" },
    { id: "start_date", name: "Start Date" }
  ]
};

export const TABS = {
  General,
  Goals,
  Dashboard,
  Retention,
  Extra,
  Pages,
  ClubReady: Clubready
};
